import styled from 'styled-components';

export const StyledImg = styled.img`
  max-width: 100%;
  border-style: none;
`;
